export default __webpack_public_path__ + "static/media/cornellbusinessreview.9d615f8e.png";